type RGBAValue = `rgba(${number}, ${number}, ${number}, ${number})`

export const generateColours = <TName extends string>(
  ...rgbValues: [TName, number, number, number][]
): { [key in TName]: (/** Decimal format (e.g. 20% is '0.2') */transparency?: number) => RGBAValue } => {
  // @ts-expect-error "key in TName" complains because we are initialising as empty.
  const colourMap: { [key in TName]: (transparency?: number) => RGBAValue } = {}

  rgbValues.forEach(([name, red, green, blue]) => {
    colourMap[name] = (transparency = 1) => `rgba(${red}, ${green}, ${blue}, ${transparency})`
  })

  return colourMap
}

/**
 * Converts a hex color code to an RGBA color string with the specified alpha value.
 *
 * @param {string} hex - The hex color code (e.g. "#RRGGBB").
 * @param {number} alpha - The alpha (opacity) value between 0 (fully transparent) and 1 (fully opaque).
 * @returns {string} The corresponding RGBA color string (e.g. "rgba(255, 255, 255, 0.5)").
 *
 * @example
 * applyAlpha("#3498db", 0.3) // returns "rgba(52, 152, 219, 0.3)"
 */
export const applyAlpha = (hex: string, alpha: number) => {
  const r = parseInt(hex.slice(1, 3), 16)
  const g = parseInt(hex.slice(3, 5), 16)
  const b = parseInt(hex.slice(5, 7), 16)
  return `rgba(${r}, ${g}, ${b}, ${alpha})`
}